module.exports = __webpack_public_path__ + "img/impacts.99b399b6.svg";